// @flow
import styled from 'styled-components'
import { media } from 'src/theme/style-utils'
import type { Theme as ThemeType } from 'src/types'

export const CopyFieldContainer = styled.div`
  width: 100%;
  margin: 5px 0 0 0;
`
export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
`
export const StyledButton = styled.button`
  background-color: transparent;
  -webkit-appearance: none;
  padding-left: 0;
`
export const StyledA = styled.a`
  background-color: transparent;
  outline: none;
  text-decoration: none;
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
  font-size: 16px;
  ${media.desktop`
    padding-left: 5px;
  `};
`
export const StyledAdmin = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0 250px 0;
  background-color: #ffffff;
  min-height: 100vh;

  ${media.tablet`
    padding: 0 20px 250px 20px;
    overflow-y: auto;
    margin: 0 auto;
  `}
  ${media.desktop`
    padding: 0 130px 130px 130px;
  `}
  ${media.giant`
    padding: 0 250px 250px 250px;
  `}
`
export const StyledArticle = styled.article`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${media.desktop`
    flex-direction: row;
    justify-content: space-between;
  `};
`
export const StyledUrl = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
  border-radius: 3px;
  font-size: 16px;
  font-family: 'RelativeBook';
  border: none;
  outline: none;
  padding: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: hidden;
`
export const OtherContainer = styled.div`
  background-color: #f0f3f5;
  border: thin solid #d2d9e2;
  border-radius: 3px;
  padding: 0 20px 20px 20px;
  margin-top: 10px;
`
export const RadioBox = styled.div`
  margin-top: 10px;
`
export const RadioContainer = styled.div`
  margin-top: 24px;
`



// WEBPACK FOOTER //
// ./src/containers/Admin/StyledElements.js